// import React, { useState, useMemo, useEffect } from "react";
// import { MdEdit, MdDelete } from "react-icons/md";
// import Table from "../Common/Table/main";
// import SearchBar from "../Common/SearchBar/main";
// import Pagination from "../Pagination/main";
// import dayjs, { Dayjs } from "dayjs";
// import { TriggerStore } from "../../Store";
// import { Popup } from "../Common/Popup/main";
// import { DatePicker, DatePickerProps } from "antd";
// import PaymentForm from "../Popups/payments";
// import { PaymentsStore } from "../../Store/PagesStore/payments";
// import DeletePopup from "../Popups/deletePopup";
// import { usePayments } from "../../hook/usePayments";
// import { PayemtsApiResponse, Payments } from "../../hook/types/payments";
// import toast from "react-hot-toast";
// import { User } from "../../hook/types/users";
// import { useProperties } from "../../hook/useProperties";

// interface PaymentInfo {
//   propertyName: string;
//   tenantName: string;
//   paymentId: string;
//   paymentStatus: string;
//   paymentCollectedOn: string;
//   paymentCollectedBy: string;
//   rentOf: string;
//   balanceAmount: number;
//   paymentMode: string;
//   amountReceived: number;
//   propertyAddress: string;
//   paymentType : string;
//   comments: string;
// }

// const initialData: PaymentInfo = {
//   propertyName: "",
//   paymentId: "",
//   tenantName: "",
//   paymentStatus: "",
//   paymentCollectedOn: "",
//   paymentCollectedBy: "",
//   rentOf: "",
//   balanceAmount: 0,
//   paymentMode: "",
//   paymentType : "",
//   comments: "",
//   amountReceived: 0,
//   propertyAddress: "",
// };

// const EditAndDeleteButton: React.FC<{
//   onEdit: () => void;
//   onDelete: () => void;
// }> = ({ onEdit, onDelete }) => {
//   return (
//     <div className="flex space-x-2">
//       <button className="btn btn-secondary" onClick={onEdit}>
//         <MdEdit className="h-5 w-5 hover:text-primary" />
//       </button>
//       <button className="btn btn-danger" onClick={onDelete}>
//         <MdDelete className="h-5 w-5 hover:text-red-500" />
//       </button>
//     </div>
//   );
// };

// const PaymentCard: React.FC = () => {
//   const {
    
//     Payments,
//     addPayment,
//     deletePayment,
//     updatePayment,
//     queryClient,
//   } = usePayments();

 
//   const uid = localStorage.getItem("R_M_uid");
//   const userData = queryClient.getQueryData(["users", uid]) as User;
//   const data = queryClient.getQueryData(["payments"]) as PayemtsApiResponse;

//   const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
//   const [activeAddressId, setActiveAddressId] = useState<any>();
//   const [DeletPopup, setDeletPopup] = useState(false);
//   const [activeId, setActiveId] = useState("");
//   const [placement, SetPlacement] =
//     useState<DatePickerProps["placement"]>("topLeft");
//   const [openPopup, setOpenPopup] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [dateFilter, setDateFilter] = useState<{
//     startDate: string;
//     endDate: string;
//   }>({
//     startDate: dayjs(`${dayjs().year()}-01-01`).format('YYYY-MM-DD'),
//     endDate: dayjs(`${dayjs().year()}-12-31`).format('YYYY-MM-DD'),
//   });
//   const [addPaymentStatus, setAddPayment] = useState(false);
//   const [selectedProperty, setSelectedProperty] =
//     useState<PaymentInfo>(initialData);
//   // Sample data for demonstration
//   // const sampleData = Array.from({ length: 100 }, (_, index) => ({
//   //   id: index + 1,
//   //   name: `Item ${index + 1}`,
//   //   description: `This is the description for item ${index + 1}`,
//   // }));

//   // State for pagination
//   const [currentPage, setCurrentPage] = useState(0);
//   const [itemsPerPage, setItemsPerPage] = useState(25);

//   // Calculate total items and the current items to display
//   //const totalItems = data?.data?.content?.length || 0;
//   // const indexOfLastItem = currentPage * itemsPerPage;
//   // const indexOfFirstItem = indexOfLastItem - itemsPerPage;\
//   // const indexOfFirstItem = currentPage * itemsPerPage; // Corrected calculation
//   // const indexOfLastItem = indexOfFirstItem + itemsPerPage; // Corrected calculation
//   // console.log("currentPage:", currentPage);
//   // console.log("itemsPerPage:", itemsPerPage);
//   // console.log("indexOfFirstItem:", indexOfFirstItem);
//   // console.log("indexOfLastItem:", indexOfLastItem);
//   // const currentItems = data?.data?.content?.slice(
//   //   indexOfFirstItem,
//   //   indexOfLastItem
//   // ) || [];
 

//   // console.log("Current Items for Export:", currentItems);
//   const { Property } = useProperties();
//  // const PropertiesData = Property() as any;
//  const PropertiesData = Property({ active: true,delete: false, page: 0, size: 10 }) as any;

//   const [propertyId, setPropertyId] = useState<number | null>(null);
//   const payments =  Payments({fromDate:dateFilter.startDate,toDate:dateFilter.endDate,page:currentPage,size:10000,propertyName: searchQuery, })

//   useEffect(() => {
//     if (payments.isSuccess) {
//      // console.log("Raw Payments Data from API:", payments.data?.data?.content);
//     }
//   }, [payments.isSuccess, payments.data]);

//   //console.log("Full Payments Data:", payments.data?.data?.content);
//   const totalItems = payments.data?.data?.content?.length || 0;
//   const indexOfFirstItem = currentPage * itemsPerPage;
//   const indexOfLastItem = indexOfFirstItem + itemsPerPage;
//   const currentItems = payments.data?.data?.content?.slice(indexOfFirstItem, indexOfLastItem) || [];
//   //console.log("Current Items for Export:", currentItems);

//   const columns = [
//     { key: "propertyName", title: "Property Name", type: "text" },
//    // { key: "propertyAddress", title: " Property Address", type: "text" },
//     { key: "tenantName", title: "Tenant Name", type: "text" },
//     { key: "paymentCollectedOn", title: "Payment Collected On", type: "date" },
//     { key: "paymentCollectedBy", title: "Payment Collected By", type: "text" },
//     { key: "paymentStatus", title: "Payment Status", type: "text" },
//     { key: "paymentMode", title: "Payment Mode", type: "text" },
//     { key : "paymentType", title : "Payment Type", type : "text"},
//     // { key: "rentOf", title: "Rent of (Month)", type: "text" },
//     { key: "rentOf", title: "Rent of (Month)", type: "date" },
//     { key: "amountReceived", title: " Amount Received", type: "number" },
//     { key: "balanceAmount", title: "Balance Amount", type: "number" },
   
//    // { key: "comments", title: "Comments", type: "text" },
//     { key: "actions", title: "Actions", type: "component" },
//   ];

//   const PaymentCollectorColumns = [
//     { key: "propertyName", title: "Property Name", type: "text" },
//     { key: "propertyAddress", title: " Property Address", type: "text" },
//     { key: "tenantName", title: "Tenant Name", type: "text" },
//     { key: "paymentStatus", title: "Payment Status", type: "text" },
//     { key: "paymentCollectedOn", title: "Payment Collected On", type: "date" },
//     { key: "paymentCollectedBy", title: "Payment Collected By", type: "text" },
//    // { key: "rentOf", title: "Rent of (Month)", type: "text" },
//    { key: "rentOf", title: "Rent of (Month)", type: "date" },
//     { key: "amountReceived", title: " Amount Received", type: "number" },
//     { key: "balanceAmount", title: "Balance Amount", type: "number" },
//     { key: "paymentMode", title: "Payment Mode", type: "text" },
//     { key : "paymentType", title : "Payment Type", type : "text"},
//     { key: "comments", title: "Comments", type: "text" },
//   ];
//   const handleEdit = (payments: PaymentInfo) => {
//     setSelectedProperty(payments);
//     setOpenPopup(true);
//   };

//   const handleDelete = () => {
//     deletePayment.mutateAsync(activeId).then(() => {
//       setDeletPopup(false);
//     });
//   };

//   const handleSubmit = async (formData: Partial<PaymentInfo>) => {
//     try {
//       if (addPaymentStatus) {
//         try {
//           await addPayment
//             .mutateAsync({
//               ...formData,
//               amountReceived: parseInt(
//                 formData.amountReceived as unknown as string
//               ),
//               balanceAmount: parseInt(
//                 formData.balanceAmount as unknown as string
//               ),
//               propertyAddress: activeAddressId,
//               // rentOf: formData.paymentCollectedOn?.slice(0, 7),
//               rentOf: formData.rentOf, // Use th
//             })
//             .then(() => {
//               setAddPayment(false);
//               setOpenPopup(false);
//             });
//         } catch (error: any) {
//         //  toast.error("something error!");
//         if (error?.response?.data?.message) {
//           toast.error(error.response.data.message);
//         } else {
//           toast.error("Something went wrong while adding payment!");
//         }
//         }
//       } else {
//        // console.log("edit", formData);
//         try {
//           await updatePayment
//             .mutateAsync({
//               id: activeId,
//               updatedPayment: {
//                 ...formData,
//                 amountReceived: parseInt(
//                   formData.amountReceived as unknown as string
//                 ),
//                 balanceAmount: parseInt(
//                   formData.balanceAmount as unknown as string
//                 ),
//                 //propertyAddress: 1,
//                 propertyAddress: activeAddressId, //slove the edit payment 
//                 rentOf: formData.rentOf, // Use the rentOf field in yyyy-MM-dd 
//               },
//             })
//             .then(() => {
//               setAddPayment(false);
//               setOpenPopup(false);
//             });
//         } catch (error: any) {
//           //toast.error("something error!");
//           if (error?.response?.data?.message) {
//           toast.error(error.response.data.message);
//         } else {
//           toast.error("Something went wrong while updating payment!");
//         }
//         }

//         setOpenPopup(false);
//       }

//       setAddPayment(false);
//     } catch (error) {
//       console.error("Error occurred during mutation:", error);
//     }
//   };

//   // const onDateRangeChange = (dateRange: Dayjs[] | null) => {
//   //   if (dateRange) {
//   //     setDateFilter({
//   //       startDate: dateRange[0].format("YYYY-MM-DD"),
//   //       endDate: dateRange[1].format("YYYY-MM-DD"),
//   //     });
//   //   }
//   // };

//   const onDateRangeChange = (dateRange: Dayjs[] | null) => {
//   if (dateRange && dateRange?.length === 2) {
//     setDateFilter({
//       startDate: dateRange[0].format("YYYY-MM-DD"),
//       endDate: dateRange[1].format("YYYY-MM-DD"),
//     });
//   } else {
//     // Reset to default date range when cleared
//     setDateFilter({
//       startDate: dayjs(`${dayjs().year()}-01-01`).format('YYYY-MM-DD'),
//       endDate: dayjs(`${dayjs().year()}-12-31`).format('YYYY-MM-DD'),
//     });
//   }
//   // Reset to first page when filter changes
//   setCurrentPage(0);
// };

//   const handleCancel = () => {
//     setOpenPopup(false);
//   };

//   const filteredProperties = useMemo(() => {
//     return data?.data?.content?.filter((payment) => {
//       const matchesSearch = payment.tenantName
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase());

//       const paymentDate = new Date(payment.paymentCollectedOn);
//       const startDate = new Date(dateFilter.startDate);
//       const endDate = new Date(dateFilter.endDate);

//       const withinDateRange =
//         (isNaN(startDate.getTime()) || paymentDate >= startDate) &&
//         (isNaN(endDate.getTime()) || paymentDate <= endDate);

//       return matchesSearch && withinDateRange;
//     });
//   }, [payments, searchQuery, dateFilter]);
//   const { RangePicker } = DatePicker;

//   useEffect(() => {
//     if (!PropertiesData.isLoading && PropertiesData.data) {
//      // console.log("PropertiesData:", PropertiesData);
//     } else if (PropertiesData.isError) {
//       console.error("Error fetching properties:", PropertiesData.error);
//     }
//   }, [PropertiesData.isLoading, PropertiesData.data, PropertiesData.isError, PropertiesData.error]);

//   return (
//     <div className=" border flex w-full flex-col">
//       {/* Header */}
//       <header className="sticky top-0 bg-white  shadow z-10">
//         <h1 className="text-2xl text-start font-bold px-5 py-2">
//           Payments
//         </h1>
//         <div className="py-4 px-5 flex flex-col w-full items-center justify-between ">
//           <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
//             <RangePicker
//               id={"dateDuration"}
//               size="large"
//               className="lg:w-fullY xl:w-auto "
//               placeholder={["start-date", "end-date"]}
//               // value={dateRange}
//               popupClassName="custom-range-picker-dropdown "
//               onChange={(dateRange) => {
//                 onDateRangeChange(dateRange as Dayjs[]);
//               }}
//             />

//             <div className="w-full sm:w-auto">
//               {/* <SearchBar
//                 onClear={() => {
//                   setSearchQuery("");
//                   setDateFilter({
//                     startDate: "",
//                     endDate: "",
//                   });
//                 }}
//                 onSearch={(query) => setSearchQuery(query)}
//               /> */}
//               <SearchBar
//   suggestionInputEnable={{
//     setActiveValue: (value: string) => {
//       setSearchQuery(value); // This will update your search query state
//     },
//     activeValue: searchQuery, // Your current search query state
//     enable: true,
//     loading: PropertiesData.isLoading,
//     onSuggestionSelect: (value: number) => {
//       const allProperties = [
//         ...(PropertiesData.data?.data?.COMMERCIAL || []),
//         ...(PropertiesData.data?.data?.RESIDENTIAL || []),
//       ];
//       setPropertyId(allProperties[value]?.id);
//       setSearchQuery(allProperties[value]?.propertyName);
//     },
//     suggestions: PropertiesData.isLoading
//       ? []
//       : [
//           ...(PropertiesData.data?.data?.COMMERCIAL || []).map((item: any) => item.propertyName),
//           ...(PropertiesData.data?.data?.RESIDENTIAL || []).map((item: any) => item.propertyName),
//         ].flat() || [],
//   }}
//   onClear={() => {
//     setSearchQuery("");
//     setDateFilter({
//       startDate: "",
//       endDate: "",
//     });
//   }}
//   // onSearch={() => {
//   //   handleSearch(); // Your existing search handler for other filters
//   // }}
//   onSearch={(query) => setSearchQuery(query)}
// />
//             </div>
//             <button
//               className="bg-primary text-white flex gap-1 justify-center  hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
//               onClick={() => {
//                 setSelectedProperty(initialData);
//                 setAddPayment(true);
//                 setOpenPopup(true);
//               }}
//             >
//               Add{" "}
//               <span className="lg:hidden sm:block md:block   xl:block">
//                 New
//               </span>
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Scrollable Table */}
//       <div className="min-w-full h-full mb-16 md:mb-16 xl:mb-0  overflow-x-auto">
//         <Table
//           columns={
//             userData?.roles[0]?.roleName === "ADMIN"
//               ? (columns as any)
//               : PaymentCollectorColumns
//           }
//           loading={payments.isLoading}
//           data={
//             payments?.data === undefined
//               ? []
//               : payments?.data?.data?.content.map((item: Payments) => ({
//                   propertyName: item.propertyName,
//                   propertyAddress: item.propertyAddress.propertyAddress,
//                   tenantName: item.tenantName,
//                   paymentStatus: item.paymentStatus,
//                   paymentCollectedOn: item.paymentCollectedOn,
//                   paymentCollectedBy: item.paymentCollectedBy,
//                   rentOf: item.rentOf,
//                   amountReceived: item.amountReceived,
//                   balanceAmount: item.balanceAmount,
//                   paymentMode: item.paymentMode,
//                   paymentType : item.paymentType,
//                   comments: item.comments,
//                   actions: (
//                     <EditAndDeleteButton
//                       onDelete={() => {
//                         setDeletPopup(true);
//                         setActiveId(JSON.stringify(item.id));
//                       }}
//                       onEdit={() => {
//                         setActiveId(JSON.stringify(item.id));
//                         handleEdit({
//                           propertyName: item.propertyName,
//                           propertyAddress: item.propertyAddress.propertyAddress,
//                           tenantName: item.tenantName,
//                           paymentStatus: item.paymentStatus,
//                           paymentCollectedOn: item.paymentCollectedOn,
//                           paymentCollectedBy: item.paymentCollectedBy,
//                           rentOf: item.rentOf,
//                           amountReceived: item.amountReceived,
//                           balanceAmount: item.balanceAmount,
//                           paymentMode: item.paymentMode,
//                           paymentType : item.paymentType,
//                           comments: item.comments,
//                           paymentId: JSON.stringify(item.id),
//                         });
//                       }}
//                     />
//                   ),
//                 }))
//           }
          
//         />
//       </div>
//       {/* <div className="flex-1  overflow-hidden"> */}
//       {/* <div className="min-w-full px-1 h-[45vh] lg:h-[58vh] overflow-auto xl:h-screen md:h-screen">
//           {payments?.data===undefined?<p>no data</p>:
//             <Table
//               columns={columns as any}
//               loading={payments.isLoading}
//               data={payments?.data?.data?.content.map((item: Payments) => ({
//                 propertyName: item.propertyName,
//                 propertyAddress: item.propertyAddress.propertyAddress,
//                 tenantName: item.tenantName,
//                 paymentStatus: item.paymentStatus,
//                 paymentCollectedOn: item.paymentCollectedOn,
//                 paymentCollectedBy: item.paymentCollectedBy,
//                 rentOf: item.rentOf,
//                 amountReceived: item.amountReceived,
//                 balanceAmount: item.balanceAmount,
//                 paymentMode: item.paymentMode,
//                 comments: item.comments,
//                 actions: (
//                   <EditAndDeleteButton
//                     onDelete={() => {
//                       setDeletPopup(true);
//                       setActiveId(JSON.stringify(item.id));
//                     }}
//                     onEdit={() => {
//                       setActiveId(JSON.stringify(item.id))
//                       handleEdit({
//                         propertyName: item.propertyName,
//                         propertyAddress: item.propertyAddress.propertyAddress,
//                         tenantName: item.tenantName,
//                         paymentStatus: item.paymentStatus,
//                         paymentCollectedOn: item.paymentCollectedOn,
//                         paymentCollectedBy: item.paymentCollectedBy,
//                         rentOf: item.rentOf,
//                         amountReceived: item.amountReceived,
//                         balanceAmount: item.balanceAmount,
//                         paymentMode: item.paymentMode,
//                         comments: item.comments,
//                         paymentId: JSON.stringify(item.id),
//                       });
//                     }}
//                   />
//                 ),
//               }))}
//             />
//           }
//         </div> */}
//       {/* </div> */}
//       {openPopup && (
//         <Popup
//           closeButton={true}
//           children={
//             <PaymentForm
//               setActiveAddressId={setActiveAddressId}
//               isLoading={addPayment.isPending || updatePayment.isPending}
//               initialData={selectedProperty as any}
//               onSubmit={handleSubmit}
//               onCancel={handleCancel}
//               isOpen={openPopup}
//               id={selectedProperty?.paymentId}
//             />
//           }
//           onClose={() => setOpenPopup(false)}
//         />
//       )}
//       {DeletPopup ? (
//         <Popup
//           children={
//             <DeletePopup
//               isLoading={deletePayment.isPending}
//               isOpen={DeletPopup}
//               onClose={() => setDeletPopup(false)}
//               onDelete={handleDelete}
//             />
//           }
//           onClose={() => setDeletPopup(false)}
//         />
//       ) : null}
//       {/* Pagination */}
//       <footer
//         className={`xl:sticky md:fixed  fixed sm:fixed lg:fixed lg:w-full bottom-0 bg-blue-50 shadow z-10 transition-width duration-300 ${
//           sidebarAction ? "w-[calc(100%)]" : "w-full"
//         }`}
//       >
//         <div className="flex justify-center space-x-2">
//           <Pagination
//             data={currentItems}
//             ExportFunction={true} // Set to true to show export buttons
//             currentPage={currentPage}
//             itemsPerPage={itemsPerPage}
//             totalItems={totalItems as any}
//             onPageChange={setCurrentPage}
//             onPageSizeChange={setItemsPerPage}
//           />
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default PaymentCard;
import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import Table from "../Common/Table/main";
import SearchBar from "../Common/SearchBar/main";
import Pagination from "../Pagination/main";
import dayjs, { Dayjs } from "dayjs";
import { TriggerStore } from "../../Store";
import { Popup } from "../Common/Popup/main";
import { DatePicker, DatePickerProps } from "antd";
import PaymentForm from "../Popups/payments";
import { PaymentsStore } from "../../Store/PagesStore/payments";
import DeletePopup from "../Popups/deletePopup";
import { usePayments } from "../../hook/usePayments";
import { PayemtsApiResponse, Payments } from "../../hook/types/payments";
import toast from "react-hot-toast";
import { User } from "../../hook/types/users";
import { useProperties } from "../../hook/useProperties";

interface PaymentInfo {
  propertyName: string;
  tenantName: string;
  paymentId: string;
  paymentStatus: string;
  paymentCollectedOn: string;
  paymentCollectedBy: string;
  rentOf: string;
  balanceAmount: number;
  paymentMode: string;
  amountReceived: number;
  propertyAddress: string;
  paymentType: string;
  comments: string;
}

const initialData: PaymentInfo = {
  propertyName: "",
  paymentId: "",
  tenantName: "",
  paymentStatus: "",
  paymentCollectedOn: "",
  paymentCollectedBy: "",
  rentOf: "",
  balanceAmount: 0,
  paymentMode: "",
  paymentType: "",
  comments: "",
  amountReceived: 0,
  propertyAddress: "",
};

const EditAndDeleteButton: React.FC<{
  onEdit: () => void;
  onDelete: () => void;
}> = ({ onEdit, onDelete }) => {
  return (
    <div className="flex space-x-2">
      <button className="btn btn-secondary" onClick={onEdit}>
        <MdEdit className="h-5 w-5 hover:text-primary" />
      </button>
      <button className="btn btn-danger" onClick={onDelete}>
        <MdDelete className="h-5 w-5 hover:text-red-500" />
      </button>
    </div>
  );
};

const PaymentCard: React.FC = () => {
  const { Payments, addPayment, deletePayment, updatePayment, queryClient } =
    usePayments();

  const uid = localStorage.getItem("R_M_uid");
  const userData = queryClient.getQueryData(["users", uid]) as User;
  const data = queryClient.getQueryData(["payments"]) as PayemtsApiResponse;

  const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
  const [activeAddressId, setActiveAddressId] = useState<any>();
  const [DeletPopup, setDeletPopup] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [placement, SetPlacement] =
    useState<DatePickerProps["placement"]>("topLeft");
  const [openPopup, setOpenPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  
  // Set default date range to current month
  const [dateFilter, setDateFilter] = useState<{
    startDate: string;
    endDate: string;
  }>({
    startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
    endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
  });
  
  const [addPaymentStatus, setAddPayment] = useState(false);
  const [selectedProperty, setSelectedProperty] =
    useState<PaymentInfo>(initialData);

  // State for pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const { Property } = useProperties();
  const PropertiesData = Property({
    active: true,
    delete: false,
    page: 0,
    size: 1000,
  }) as any;

  const [propertyId, setPropertyId] = useState<number | null>(null);
  const payments = Payments({
    fromDate: dateFilter.startDate,
    toDate: dateFilter.endDate,
    page: 0, // Always get all data for filtering
    size: 10000,
    propertyName: searchQuery,
  });

  // Filter payments based on search query and date range
  const filteredPayments = useMemo(() => {
    if (!payments.data?.data?.content) return [];

    return payments.data.data.content.filter((payment) => {
      const matchesSearch = payment.tenantName
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      const paymentDate = new Date(payment.paymentCollectedOn);
      const startDate = new Date(dateFilter.startDate);
      const endDate = new Date(dateFilter.endDate);
      endDate.setHours(23, 59, 59, 999); // Include the entire end date

      const withinDateRange =
        (isNaN(startDate.getTime()) || paymentDate >= startDate) &&
        (isNaN(endDate.getTime()) || paymentDate <= endDate);

      return matchesSearch && withinDateRange;
    });
  }, [payments.data, searchQuery, dateFilter]);

  // Calculate pagination values
  const totalItems = filteredPayments.length;
  const indexOfFirstItem = currentPage * itemsPerPage;
  const indexOfLastItem = Math.min(
    indexOfFirstItem + itemsPerPage,
    totalItems
  );
  const currentItems = filteredPayments.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const columns = [
    { key: "propertyName", title: "Property Name", type: "text" },
    { key: "tenantName", title: "Tenant Name", type: "text" },
    { key: "paymentCollectedOn", title: "Payment Collected On", type: "date" },
    { key: "paymentCollectedBy", title: "Payment Collected By", type: "text" },
    { key: "paymentStatus", title: "Payment Status", type: "text" },
    { key: "paymentMode", title: "Payment Mode", type: "text" },
    { key: "paymentType", title: "Payment Type", type: "text" },
    { key: "rentOf", title: "Rent of (Month)", type: "date" },
    { key: "amountReceived", title: " Amount Received", type: "number" },
    { key: "balanceAmount", title: "Balance Amount", type: "number" },
    { key: "actions", title: "Actions", type: "component" },
  ];

  const PaymentCollectorColumns = [
    { key: "propertyName", title: "Property Name", type: "text" },
    { key: "propertyAddress", title: " Property Address", type: "text" },
    { key: "tenantName", title: "Tenant Name", type: "text" },
    { key: "paymentStatus", title: "Payment Status", type: "text" },
    { key: "paymentCollectedOn", title: "Payment Collected On", type: "date" },
    { key: "paymentCollectedBy", title: "Payment Collected By", type: "text" },
    { key: "rentOf", title: "Rent of (Month)", type: "date" },
    { key: "amountReceived", title: " Amount Received", type: "number" },
    { key: "balanceAmount", title: "Balance Amount", type: "number" },
    { key: "paymentMode", title: "Payment Mode", type: "text" },
    { key: "paymentType", title: "Payment Type", type: "text" },
    { key: "comments", title: "Comments", type: "text" },
  ];

  const handleEdit = (payments: PaymentInfo) => {
    setSelectedProperty(payments);
    setOpenPopup(true);
  };

  const handleDelete = () => {
    deletePayment.mutateAsync(activeId).then(() => {
      setDeletPopup(false);
    });
  };

  const handleSubmit = async (formData: Partial<PaymentInfo>) => {
    try {
      if (addPaymentStatus) {
        try {
          await addPayment
            .mutateAsync({
              ...formData,
              amountReceived: parseInt(
                formData.amountReceived as unknown as string
              ),
              balanceAmount: parseInt(
                formData.balanceAmount as unknown as string
              ),
              propertyAddress: activeAddressId,
              rentOf: formData.rentOf,
            })
            .then(() => {
              setAddPayment(false);
              setOpenPopup(false);
            });
        } catch (error: any) {
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong while adding payment!");
          }
        }
      } else {
        try {
          await updatePayment
            .mutateAsync({
              id: activeId,
              updatedPayment: {
                ...formData,
                amountReceived: parseInt(
                  formData.amountReceived as unknown as string
                ),
                balanceAmount: parseInt(
                  formData.balanceAmount as unknown as string
                ),
                propertyAddress: activeAddressId,
                rentOf: formData.rentOf,
              },
            })
            .then(() => {
              setAddPayment(false);
              setOpenPopup(false);
            });
        } catch (error: any) {
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong while updating payment!");
          }
        }

        setOpenPopup(false);
      }

      setAddPayment(false);
    } catch (error) {
      console.error("Error occurred during mutation:", error);
    }
  };

  const onDateRangeChange = (dateRange: Dayjs[] | null) => {
    if (dateRange && dateRange.length === 2) {
      setDateFilter({
        startDate: dateRange[0].format("YYYY-MM-DD"),
        endDate: dateRange[1].format("YYYY-MM-DD"),
      });
    } else {
      // Reset to current month when cleared
      setDateFilter({
        startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
        endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
      });
    }
    // Reset to first page when filter changes
    setCurrentPage(0);
  };

  const handleCancel = () => {
    setOpenPopup(false);
  };

  const { RangePicker } = DatePicker;

  useEffect(() => {
    if (!PropertiesData.isLoading && PropertiesData.data) {
      // Properties data loaded
    } else if (PropertiesData.isError) {
      console.error("Error fetching properties:", PropertiesData.error);
    }
  }, [
    PropertiesData.isLoading,
    PropertiesData.data,
    PropertiesData.isError,
    PropertiesData.error,
  ]);

  return (
    <div className=" border flex w-full flex-col">
      {/* Header */}
      <header className="sticky top-0 bg-white  shadow z-10">
        <h1 className="text-2xl text-start font-bold px-5 py-2">Payments</h1>
        <div className="py-4 px-5 flex flex-col w-full items-center justify-between ">
          <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
            <RangePicker
              id={"dateDuration"}
              size="large"
              className="lg:w-fullY xl:w-auto "
              placeholder={["start-date", "end-date"]}
              // Set default value to current month
              defaultValue={[dayjs().startOf('month'), dayjs().endOf('month')]}
              popupClassName="custom-range-picker-dropdown "
              onChange={(dateRange) => {
                onDateRangeChange(dateRange as Dayjs[]);
              }}
            />

            <div className="w-full sm:w-auto">
            <SearchBar
  suggestionInputEnable={{
    setActiveValue: (value: string) => {
      setSearchQuery(value);
    },
    activeValue: searchQuery,
    enable: true,
    loading: PropertiesData.isLoading,
    onSuggestionSelect: (index: number) => {
      // Get all properties
      const allProperties = [
        ...(PropertiesData.data?.data?.COMMERCIAL || []),
        ...(PropertiesData.data?.data?.RESIDENTIAL || []),
      ];
      
      // Get all property names
      const allPropertyNames = allProperties.map(property => property.propertyName);
      
      // Filter property names based on current search query
      const filteredPropertyNames = allPropertyNames.filter(name =>
        name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      
      // Get the selected property name from the filtered list
      if (index >= 0 && index < filteredPropertyNames.length) {
        const selectedPropertyName = filteredPropertyNames[index];
        
        // Find the property with this exact name
        const selectedProperty = allProperties.find(
          property => property.propertyName === selectedPropertyName
        );
        
        if (selectedProperty) {
          setPropertyId(selectedProperty.id);
          setSearchQuery(selectedProperty.propertyName);
        }
      }
    },
    suggestions: PropertiesData.isLoading
      ? []
      : [
          ...(PropertiesData.data?.data?.COMMERCIAL || []).map(
            (item: any) => item.propertyName
          ),
          ...(PropertiesData.data?.data?.RESIDENTIAL || []).map(
            (item: any) => item.propertyName
          ),
        ].flat() || [],
  }}
  onClear={() => {
    setSearchQuery("");
    setDateFilter({
      startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
      endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
    });
  }}
  onSearch={(query) => setSearchQuery(query)}
/>
            </div>
            <button
              className="bg-primary text-white flex gap-1 justify-center  hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
              onClick={() => {
                setSelectedProperty(initialData);
                setAddPayment(true);
                setOpenPopup(true);
              }}
            >
              Add{" "}
              <span className="lg:hidden sm:block md:block   xl:block">
                New
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Scrollable Table */}
      <div className="min-w-full h-full mb-16 md:mb-16 xl:mb-0  overflow-x-auto">
        <Table
          columns={
            userData?.roles[0]?.roleName === "ADMIN"
              ? (columns as any)
              : PaymentCollectorColumns
          }
          loading={payments.isLoading}
          data={
            payments?.data === undefined
              ? []
              : currentItems.map((item: Payments) => ({
                  propertyName: item.propertyName,
                  propertyAddress: item.propertyAddress.propertyAddress,
                  tenantName: item.tenantName,
                  paymentStatus: item.paymentStatus,
                  paymentCollectedOn: item.paymentCollectedOn,
                  paymentCollectedBy: item.paymentCollectedBy,
                  rentOf: item.rentOf,
                  amountReceived: item.amountReceived,
                  balanceAmount: item.balanceAmount,
                  paymentMode: item.paymentMode,
                  paymentType: item.paymentType,
                  comments: item.comments,
                  actions: (
                    <EditAndDeleteButton
                      onDelete={() => {
                        setDeletPopup(true);
                        setActiveId(JSON.stringify(item.id));
                      }}
                      onEdit={() => {
                        setActiveId(JSON.stringify(item.id));
                        handleEdit({
                          propertyName: item.propertyName,
                          propertyAddress: item.propertyAddress.propertyAddress,
                          tenantName: item.tenantName,
                          paymentStatus: item.paymentStatus,
                          paymentCollectedOn: item.paymentCollectedOn,
                          paymentCollectedBy: item.paymentCollectedBy,
                          rentOf: item.rentOf,
                          amountReceived: item.amountReceived,
                          balanceAmount: item.balanceAmount,
                          paymentMode: item.paymentMode,
                          paymentType: item.paymentType,
                          comments: item.comments,
                          paymentId: JSON.stringify(item.id),
                        });
                      }}
                    />
                  ),
                }))
          }
        />
      </div>

      {openPopup && (
        <Popup
          closeButton={true}
          children={
            <PaymentForm
              setActiveAddressId={setActiveAddressId}
              isLoading={addPayment.isPending || updatePayment.isPending}
              initialData={selectedProperty as any}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              isOpen={openPopup}
              id={selectedProperty?.paymentId}
            />
          }
          onClose={() => setOpenPopup(false)}
        />
      )}
      {DeletPopup ? (
        <Popup
          children={
            <DeletePopup
              isLoading={deletePayment.isPending}
              isOpen={DeletPopup}
              onClose={() => setDeletPopup(false)}
              onDelete={handleDelete}
            />
          }
          onClose={() => setDeletPopup(false)}
        />
      ) : null}
      {/* Pagination */}
      <footer
        className={`xl:sticky md:fixed  fixed sm:fixed lg:fixed lg:w-full bottom-0 bg-blue-50 shadow z-10 transition-width duration-300 ${
          sidebarAction ? "w-[calc(100%)]" : "w-full"
        }`}
      >
        <div className="flex justify-center space-x-2">
          <Pagination
            data={currentItems}
            ExportFunction={true}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onPageChange={setCurrentPage}
            onPageSizeChange={setItemsPerPage}
          />
        </div>
      </footer>
    </div>
  );
};

export default PaymentCard;